export default __webpack_public_path__ + "media/images/spacecore-d4f24a9fcffbd92c353521dddeb39401.png";